import {
  CreateObservationRequest,
  CreateObservationResponse,
  DeleteObservationRequest,
  GetObservationsRequest,
  GetObservationsResponse,
  UpdateObservationRequest,
} from '../../../../../api-service/clients';
import { moduleClientFactory } from '../../../../../api-service/module-client-factory';

const observationsClient = moduleClientFactory.createCitizenServiceProviderObservationsClient(true);

export function getObservations(request: GetObservationsRequest): Promise<GetObservationsResponse> {
  return observationsClient.getObservations(request);
}

export function createObservation(request: CreateObservationRequest): Promise<CreateObservationResponse> {
  return observationsClient.createObservation(request);
}

export function updateObservation(request: UpdateObservationRequest): Promise<unknown> {
  return observationsClient.updateObservation(request);
}

export function deleteObservation(request: DeleteObservationRequest): Promise<unknown> {
  return observationsClient.deleteObservation(request);
}
